import { render, staticRenderFns } from "./ModalEdit.vue?vue&type=template&id=0a60728c&scoped=true&"
import script from "./ModalEdit.vue?vue&type=script&lang=js&"
export * from "./ModalEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalEdit.vue?vue&type=style&index=0&id=0a60728c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60728c",
  null
  
)

export default component.exports